module.exports = EventEmitter2;